import {DocumentTemplateElementService} from 'services/documentTemplateElementService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {DocumentTemplateElement} from 'types/documentTemplateElement';

export const DocumentTemplateElementThunks =
  createEntityThunks<DocumentTemplateElement>(
    'documentTemplateElement',
    DocumentTemplateElementService,
    {activate: true, deactivate: true},
  );
